import { format } from 'date-fns';

export function formatDate(date: string, f = 'dd. MM. yyyy') {
  try {
    return format(new Date(date), f);
  } catch (error) {
    console.error(error);
    return '';
  }
}
